module.exports = __webpack_public_path__ + "img/step-5.4b41a8e0.jpg";